import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import ServicesModule from '../../api/services/ServicesModule';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
var imageUrl = process.env.REACT_APP_LARAVEL_Service_IMAGE_URL;
const EditServices = () => {

  const params = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState()
  const [accessory, setAccessory] = useState([]);
  const [serviceModal, setServiceModal] = useState(false);
  const [error, setError] = useState("")
  const [Type, setType] = useState("")
  const [isLoading, setisloading] = useState(true);
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const options = [
    { value: '0', label: 'Fixed' },
    { value: '1', label: 'Per Night' },

  ]
  useEffect(() => {
    var id = params.id;
    if (localStorage.getItem("admintoken")) {
      getServiceByID(id);
    }
    else {
      navigate('/')
    }


  }, []);

  const getServiceByID = async (id) => {
    try {
      let accessory = await ServicesModule.show(id).json();
      setAccessory(accessory.data);
      let selecttype = options.filter(function (item) {
        return item.value === accessory.data.type.toString();
      });

      setType(selecttype)

      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const handlehome = ishome => {
    setType(ishome)
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title":event.target.de_title.value,
        "price": event.target.price.value,
        "per_month": event.target.per_month.value,
        "description": event.target.description.value,
        "de_description":event.target.de_description.value,
        "icon": file ? file.split(',')[1] : "",

        "type": Type.value ? Type.value : 1,
      }
      let responseData = await ServicesModule.update(params.id, userData).json()
      if (responseData.status === true) {
        setServiceModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Services" pageTitle={'Services'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Service</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          accessory.title
                            ? accessory.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={
                          accessory.de_title
                            ? accessory.de_title
                            : ''
                        }/>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='price' id="val-number" defaultValue={
                        accessory.price
                          ? accessory.price
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Month Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='per_month' id="val-number" defaultValue={
                        accessory.per_month
                          ? accessory.per_month
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description' defaultValue={
                        accessory.description
                          ? accessory.description
                          : ''
                      } ></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description' defaultValue={
                        accessory.de_description
                          ? accessory.de_description
                          : ''
                      } ></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Image <span className="text-danger">*</span></label>

                      <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + accessory.icon} alt='' />
                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Type <span className="text-danger">*</span></label>

                      <Select
                        options={options}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={Type}
                        onChange={handlehome}

                      />
                    </div>

                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={serviceModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setServiceModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Service Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/services'} variant="danger light" onClick={() => setServiceModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditServices;